// React 19 hoists <title>, <meta>, <link> from anywhere in the tree to <head>.
// One small component per page, using canonical production URLs so shares
// are consistent regardless of where the reader lands.

const SITE_URL = "https://truth4parents.com";
const SITE_NAME = "You Are Not Alone";
const DEFAULT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/4557cc87-798c-47bd-b347-d002eb8baf36/images/9607f2d9374d64d9ef140b0cd80f9c96c49a7e27998882fda1435ed6b902b2b7.png";

export default function PageMeta({
  title,
  description,
  path = "/",
  image,
  type = "website",
  publishedTime,
}) {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  const fullTitle = title
    ? `${title} — ${SITE_NAME}`
    : `${SITE_NAME} — Support and a voice for families`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title || SITE_NAME} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_GB" />
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || SITE_NAME} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </>
  );
}
